<template>
  <div>
    <section ref="raiz" class="lluvia-sobres">

      <img 
        ref="zapatillaTopLeft" 
        src="@/assets/zap.png" 
        alt="" 
        class="dc-zapatilla zapatilla-tl" 
      />
      <img 
        ref="zapatillaMidRight" 
        src="@/assets/bola.png" 
        alt="" 
        class="dc-zapatilla zapatilla-mr" 
      />
      <img 
        ref="zapatillaBottomLeft" 
        src="@/assets/bola.png" 
        alt="" 
        class="dc-zapatilla zapatilla-bl" 
      />

      <div class="contenido">

        <h2 ref="tituloRef" class="titulo">
          <span class="serif">Money</span><br />
          <span class="script">Envelope</span>
        </h2>

        <p ref="textoRef" class="texto">
          Your presence is the most valuable gift to me. ✨
          But if you would like to give me a special gift, I will receive it with much love.
          <br>
          <img
            ref="sobreRef"
            :src="sobrePng"
            class="icono-sobre"
            alt="Envelope"
          />
        </p>

        <p ref="graciasRef" class="gracias">
          THANK YOU!
        </p>

      </div>

      <div
        ref="lluviaIzq"
        class="lluvia lluvia-izq"
        aria-hidden="true"
      ></div>

      <div
        ref="lluviaDer"
        class="lluvia lluvia-der"
        aria-hidden="true"
      ></div>

    </section>

    <!-- <section ref="raizNinos" class="lluvia-sobres">

  <div class="contenido">
    <h2 ref="tituloNinosRef" class="titulo">
      <span class="serif">Children Welcome!</span>
    </h2>

    <p ref="textoNinosRef" class="texto">
      In order to maintain a pleasant and safe environment, we kindly ask that children remain under the supervision of their parents at all times.
    </p>

    <p ref="graciasNinosRef" class="gracias"></p>
  </div>

  <div ref="lluviaNinosIzq" class="lluvia lluvia-izq"></div>
  <div ref="lluviaNinosDer" class="lluvia lluvia-der"></div>

</section> -->
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import sobrePng from '@/assets/ss.png'

gsap.registerPlugin(ScrollTrigger)

export default {

  name: 'LluviaDeSobres',

  setup() {

    // Refs del DOM
    const raiz = ref(null)

    const tituloRef = ref(null)
    const textoRef = ref(null)

    const sobreRef = ref(null)

    const lluviaTextoRef = ref(null)

    const zelleBoxRef = ref(null)
    const numeroRef = ref(null)

    const graciasRef = ref(null)

    // Contenedores lluvia
    const lluviaIzq = ref(null)
    const lluviaDer = ref(null)

    // Refs Zapatillas Bloque 1
    const zapatillaTopLeft = ref(null)
    const zapatillaMidRight = ref(null)
    const zapatillaBottomLeft = ref(null)

    // Refs Bloque Niños
    const raizNinos = ref(null)
    const tituloNinosRef = ref(null)
    const textoNinosRef = ref(null)
    const graciasNinosRef = ref(null)
    const lluviaNinosIzq = ref(null)
    const lluviaNinosDer = ref(null)


    let ctx

    const crearLluvia = (
      contenedorEl,
      lado = 'der',
      cantidad = 12
    ) => {

      if (!contenedorEl) return

      for (let i = 0; i < cantidad; i++) {

        const el = document.createElement('img')

        el.src = sobrePng
        el.className = 'sobre-lluvia'

        el.style.position = 'absolute'
        el.style.width = '40px'

        contenedorEl.appendChild(el)

        const rndDelay = gsap.utils.random(0, 0.8)
        const rndDur = gsap.utils.random(2, 3)

        const xStart = lado === 'der' ? 100 : -20
        const xEnd = lado === 'der' ? -30 : 110

        gsap.fromTo(
          el,
          {
            xPercent: xStart,
            yPercent: -20,
            rotate: gsap.utils.random(-30, 30),
            opacity: 0,
            scale: 0.4
          },
          {
            xPercent: xEnd,
            yPercent: 130,
            rotate: gsap.utils.random(100, 360),
            opacity: 0.8,
            scale: gsap.utils.random(0.5, 0.8),
            duration: rndDur,
            delay: rndDelay,
            ease: 'none',
            onComplete: () => el.remove()
          }
        )
      }
    }

    onMounted(async () => {

      await nextTick()

      ctx = gsap.context(() => {

        // 🔥 TIMELINE BLOQUE 1
        const tl1 = gsap.timeline({

          scrollTrigger: {
            trigger: raiz.value,
            start: "top 75%",
            toggleActions: "play none none none",
            once: true
          }

        })

        /* 🔥 TITULO */
        tl1.from(
          tituloRef.value.querySelector('.serif'),
          {
            y: 50,
            opacity: 0,
            duration: 0.8,
            ease: "back.out(1.7)"
          }
        )

        .from(
          tituloRef.value.querySelector('.script'),
          {
            y: 40,
            opacity: 0,
            duration: 0.8,
            ease: "back.out(1.7)"
          },
          "-=0.5"
        )

        /* ANIMACIÓN INICIAL ZAPATILLAS BLOQUE 1 */
        .from([zapatillaTopLeft.value, zapatillaMidRight.value, zapatillaBottomLeft.value], {
          opacity: 0,
          scale: 0.6,
          duration: 0.7,
          stagger: 0.15,
          ease: 'back.out(1.4)'
        }, '>-0.4')

        /* 🔥 TEXTO */
        .from(
          textoRef.value,
          {
            opacity: 0,
            y: 30,
            duration: 0.7
          },
          "-=0.4"
        )

        /* 🔥 SOBRE */
        .from(
          sobreRef.value,
          {
            scale: 0,
            rotation: -45,
            opacity: 0,
            duration: 0.9,
            ease: "elastic.out(1, 0.7)"
          },
          "-=0.2"
        )

        /* 🔥 ZELLE */
        .from(
          zelleBoxRef.value,
          {
            opacity: 0,
            x: -80,
            duration: 0.7,
            ease: "power4.out"
          },
          "-=0.2"
        )

        /* 🔥 NUMERO */
        .from(
          numeroRef.value,
          {
            opacity: 0,
            x: 80,
            duration: 0.7,
            ease: "power4.out"
          },
          "-=0.5"
        )

        /* 🔥 GRACIAS */
        .from(
          graciasRef.value,
          {
            opacity: 0,
            y: 25,
            scale: 0.8,
            duration: 0.7,
            ease: "back.out(1.8)"
          },
          "-=0.4"
        )

        /* 🔥 TEXTO LLUVIA */
        .from(
          lluviaTextoRef.value,
          {
            opacity: 0,
            y: 20
          },
          "-=0.5"
        )

        /* 🔥 LLUVIA */
        .add(() => {

          crearLluvia(lluviaDer.value, 'der')
          crearLluvia(lluviaIzq.value, 'izq')

        }, "-=0.5")

        /* 🔥 LATIDO ZELLE */
        if (zelleBoxRef.value) {
          gsap.to(zelleBoxRef.value, {
            scale: 1.04,
            duration: 1.8,
            repeat: -1,
            yoyo: true,
            ease: 'sine.inOut'
          })
        }

 
        // 🔥 TIMELINE BLOQUE NIÑOS
        const tl2 = gsap.timeline({
          scrollTrigger: {
            trigger: raizNinos.value,
            start: "top 75%",
            toggleActions: "play none none none",
            once: true
          }
        })

        tl2.from(tituloNinosRef.value, {
          y: 40,
          opacity: 0,
          duration: 0.8,
          ease: "back.out(1.7)"
        })
        /* ANIMACIÓN INICIAL ZAPATILLAS BLOQUE NIÑOS */
      
        .from(textoNinosRef.value, {
          opacity: 0,
          y: 30,
          duration: 0.7
        }, "-=0.4")

         }, raiz.value)

    })

    onUnmounted(() => {

      if (ctx) ctx.revert()

    })

    return {

      raiz,

      tituloRef,
      textoRef,

      sobreRef,

      lluviaTextoRef,

      zelleBoxRef,
      numeroRef,

      graciasRef,

   

      sobrePng,

      zapatillaTopLeft,
      zapatillaMidRight,
      zapatillaBottomLeft,

      // Regresos Bloque Niños
      raizNinos,
      tituloNinosRef,
      textoNinosRef,
      graciasNinosRef,
      lluviaNinosIzq,
      lluviaNinosDer,
  
    }
  }
}
</script>

<style scoped>

.lluvia-sobres{
  position: relative;
  max-width: 520px;
  margin: 0 auto;
  padding: 48px 20px 56px;
  text-align: center;
  background: #f0c9d3;
  overflow: hidden;
}

.contenido{
  position: relative;
  z-index: 2;
}

.titulo{
  margin: 0 0 10px;
  color: #fff;
  line-height: 1.05;
}

.titulo .serif{
  font-family: 'britishgruesa', serif;
  font-size: 56px;
  display: inline-block;
}

.titulo .script{
  font-family: 'nombre', cursive;
  font-size: 44px;
  font-weight: 400;
  display: inline-block;
  opacity: .95;
}

.texto{
  font-family: 'quote', serif;
  color: #fff;
  font-size: 16px;
  line-height: 1.7;
  max-width: 420px;
  margin: 12px auto 18px;
  opacity: .95;
}

.icono-sobre{
  width: 110px;
  height: auto;
  display: block;
  margin: 8px auto 16px;

  filter:
    drop-shadow(0 6px 12px rgba(0,0,0,.12));
}

/* 🔥 ZELLE */
.zelle-box{
font-family: 'britishgruesa', serif;
  font-size: 56px;
  display: inline-block;
  color: #ffff;
}

/* 🔥 NUMERO */
.numero-zelle{

  font-family:'padres', serif;
  font-size:26px;

  color:#ffffff;

  letter-spacing:.12em;

  margin-bottom:20px;

  text-shadow:
    0 2px 8px rgba(0,0,0,.12);
}

.gracias{
  font-family: 'padres', serif;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: .08em;
  font-weight: 800;
  margin: 4px 0 0;
}

.lluvia{
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
}

.lluvia-izq{
  left: 0;
}

.lluvia-der{
  right: 0;
}

.sobre-lluvia{
  position: absolute;
  top: -10%;
  left: 0;

  width: 28px;
  height: auto;

  opacity: 0.9;

  filter:
    drop-shadow(0 4px 8px rgba(0,0,0,.10));
}

.lluvia-texto{
  font-family: 'padres', serif;
  font-size: 18px;
  color: #ffffff;
  margin-top: 8px;
  letter-spacing: .05em;
  opacity: .95;
}

/* ===== ESTILOS DE LAS ZAPATILLAS DE BALLET ===== */
.dc-zapatilla {
  position: absolute;
  width: 155px;
  height: auto;
  opacity:0 !important;
  z-index: 1;
  pointer-events: none;
}

.zapatilla-tl {
  top: 20px;  opacity:0 !important;

  left: 10px;
}

.zapatilla-mr {
  top: 62%;  opacity:0 !important;

  right: -48px;
  width: 60px;
  transform: rotate(20deg);
}

.zapatilla-bl {
  bottom: 80px;  opacity:0 !important;

  left: -22px !important;
}

@media (max-width: 380px){

  .titulo .serif{
    font-size: 50px;
  }

  .titulo .script{
    font-size: 40px;
  }

  .icono-sobre{
    width: 96px;
  }

  .zelle-box{
    font-size:32px;
    padding:10px 28px;
  }

  .numero-zelle{
    font-size:22px;
  }
}

/* 🔥 LINEA DIVISORIA */
.linea-divisoria{

  width:180px;
  height:2px;

  margin:26px auto 18px;

  border-radius:999px;

  background:
    linear-gradient(
      90deg,
      transparent,
      rgba(255,255,255,.95),
      transparent
    );

  box-shadow:
    0 0 12px rgba(255,255,255,.25);
}

</style>